import {
  EVENT_DETAILS_FETCH_START,
  EVENT_DETAILS_FETCH_FAIL,
  EVENT_DETAILS_FETCH_SUCCESS,
} from '../constants/event.actionTypes'

const initialState = {
  event: {},
  fetchEventDetailsProgress: {
    loading: false,
    errors: null,
  },
}

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Event Details
    case EVENT_DETAILS_FETCH_START: {
      return Object.assign({}, state, {
        fetchEventDetailsProgress: {
          loading: true,
          errors: null,
        },
      })
    }
    case EVENT_DETAILS_FETCH_FAIL: {
      return Object.assign({}, state, {
        fetchEventDetailsProgress: {
          loading: false,
          errors: action.error,
        },
      })
    }
    case EVENT_DETAILS_FETCH_SUCCESS: {
      return Object.assign({}, state, {
        fetchEventDetailsProgress: {
          loading: false,
          errors: null,
        },
        event: action.value,
      })
    }

    default:
      return state
  }
}

export default eventReducer
export { initialState }
